export default "__VITE_ASSET__3cd4abaf__"